import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleTool = {
  namespaced: true,

  state: {
    name: 'tool',
    nextSeqCode: null,

    tools: []
  },

  mutations,
  getters,
  actions
}

export default moduleTool;